/**
 * App brand assets — Vite-bundled so deploy works even if /icons/*.svg MIME fails.
 */
import appIconPng from '../../icons/icon-192.png';

export const APP_ICON_URL = appIconPng;
